import { MASK_PLACEHOLDER_PREVIEW_IMG_SRC } from 'components/VisualStudioPlayground/Shapes/MaskShape/constants'
import { useId } from 'react'

export const ArrowLeft = () => {
  const imageId = useId()
  const patternId = useId()

  return (
    <svg width="81" viewBox="0 0 81 74" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M34.0854 0.644157L0.536316 36.8285L34.0854 73.0118V56.3223H80.4015V17.3347H34.0854V0.644157Z"
        fill={`url(#${patternId})`}
        fillOpacity="0.6"
      />
      <defs>
        <pattern id={patternId} patternContentUnits="objectBoundingBox" width="1" height="1">
          <use xlinkHref={`#${imageId}`} transform="matrix(0.0110972 0 0 0.0111111 0.000626541 0)" />
        </pattern>
        <image id={imageId} width="90" height="90" xlinkHref={MASK_PLACEHOLDER_PREVIEW_IMG_SRC} />
      </defs>
    </svg>
  )
}
